
import Service from "../domain/Service";

export default {
	props: {
		servicesService: {
			type: Object,
		},
	},
	data() {
		return {
			service: {}
		};
	},
	methods: {
		async updateService(service: Service) {
			await this.servicesService.updateService(service);
			this.$emitter.emit("eventEmitted", { time: 3000, show: true, message: "Service saved successfully!"});
		},
		async addParameter(service, a, b) {
			service.data[a][b].push({ uuid: (Math.random() + 1).toString(36).substring(7)});
		},
		async deleteParameter(service, a, b, parameter) {
			service.data[a][b].splice(service.data.request.path.indexOf(parameter), 1);
		},
	},
	async created() {
		const idService = this.$route.params.idService;
		this.service = await this.servicesService.getService(idService);
	}
};
